import _ from 'lodash';
import { MenuItem, Select } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Accordion } from 'react-accessible-accordion';
import { useDispatch, useSelector } from 'react-redux';

import ActivityCard from './ActivityCard/index.js';
import 'react-accessible-accordion/dist/fancy-example.css';
import { setActiveActivityBox } from '../../store/Activities/index.js';

const AllActivities = (props) => {
    const dispatch = useDispatch();
    let { selectedTab, singlePageData, searchText, singleActivityId, handleEmailClick } = props;
    let { currentWorkspace } = useSelector(state => state['Settings']);

    let [accordionKey, setAccordionKey] = useState(0);
    let [isExpandAll, setIsExpandAll] = useState(false);
    let [expandedActivities, setExpandedActivities] = useState([]);
    let [userFilterActivity, setUserFilterActivity] = useState('All Users');

    // Generate unique activity IDs across all groups
    const getAllActivityIds = () => {
        let activityIds = [];
        let globalIndex = 0;
        if (singlePageData?.['activitiesGrouped']) {
            singlePageData['activitiesGrouped'].forEach((group) => {
                group?.['activities']?.forEach(() => {
                    activityIds.push(`a-${globalIndex}`);
                    globalIndex++;
                })
            })
        }
        return activityIds;
    };

    // Handle expand/collapse all
    useEffect(() => {
        if (isExpandAll) setExpandedActivities(getAllActivityIds());
        else setExpandedActivities([]);
        setAccordionKey(prev => prev + 1); // Force re-render of accordions
    }, [isExpandAll]);

    useEffect(() => { if (singleActivityId) setExpandedActivities([`a-0`]) }, [singleActivityId]);

    return (
        <div className='tab-detail-box'>
            {!singleActivityId &&
                <div className='top-btn-area'>
                    {selectedTab != 'all' && <button className='btn-style-new' onClick={() => {
                        // Determine object type from URL
                        const pathParts = window.location.pathname.split('/');
                        const hasWorkspaceId = pathParts[1] && pathParts[1].match(/^[a-fA-F0-9]{24}$/);
                        const objectType = hasWorkspaceId ? pathParts[2] : pathParts[1];

                        // Build associations object based on object type
                        const isCommunication = ['sms', 'call', 'whatsapp'].includes(selectedTab);
                        const associations = {};
                        if (objectType === 'deals') associations['deals'] = [singlePageData['_id']];
                        if (objectType === 'companies') associations['companies'] = [singlePageData['_id']];
                        if (objectType === 'contacts') associations['contacts'] = [singlePageData['_id']];
                        else if (isCommunication && singlePageData?.['contacts']?.length) {
                            associations['contacts'] = singlePageData['contacts'].filter(c => c['phone']).map(c => c['_id']);
                        }

                        if (selectedTab === 'email' && handleEmailClick) handleEmailClick();
                        else dispatch(setActiveActivityBox({ activityBox: selectedTab, associations }));
                    }}> Create {_.capitalize(selectedTab)}</button>}
                    {singlePageData?.['activitiesGrouped'] && singlePageData['activitiesGrouped'].length > 0 && (
                        <button className='btn-style-border' onClick={() => setIsExpandAll(!isExpandAll)}>{isExpandAll ? 'Collapse All' : 'Expand All'}</button>
                    )}
                    <Select
                        size='small'
                        displayEmpty
                        variant='standard'
                        value={userFilterActivity}
                        onChange={(e) => setUserFilterActivity(e['target']['value'])}
                        renderValue={(selected) => {
                            if (!selected || selected === 'all') return 'All Users';
                            const member = currentWorkspace['members']?.find(m => m['_id'] === selected);
                            return member ? (member['firstName'] ? member['firstName'] + ' ' + member['lastName'] : member['email']) : 'All Users';
                        }}>
                        <MenuItem value='All Users'>All Users</MenuItem>
                        {currentWorkspace['members'] && currentWorkspace['members'].map((member) => <MenuItem key={member['_id']} value={member['_id']}>{member['firstName'] ? member['firstName'] + ' ' + member['lastName'] : member['email']}</MenuItem>)}
                    </Select>
                </div>
            }
            <div className='highlights-bottom-accordian style-call'>
                <div className='main-side-accordian'>
                    {(() => {
                        if (!singlePageData?.['activitiesGrouped'] || singlePageData['activitiesGrouped'].length === 0)
                            return <div style={{ textAlign: 'center', padding: '40px 20px', color: '#89868D' }} className='notfound-area'>
                                <div className='img-box'><img alt="..." src={require('../../static/img/not-found.png')} /></div>
                                <p>No activities found</p>
                            </div>

                        const filteredGroups = singlePageData['activitiesGrouped'].map((group, index) => {
                            let activities = group?.['activities'].filter((activity) => {
                                const typeMatch = selectedTab == 'all' || selectedTab == activity?.['type'];
                                const userMatch = !userFilterActivity || userFilterActivity == 'All Users' || activity?.['assignedTo']?.['_id'] == userFilterActivity || activity?.['createdBy']?.['_id'] == userFilterActivity;
                                const searchMatch = !searchText || activity?.['title']?.toLowerCase().includes(searchText.toLowerCase()) || activity?.['description']?.toLowerCase().includes(searchText.toLowerCase());
                                return typeMatch && userMatch && searchMatch;
                            });
                            if (singleActivityId) activities = activities.filter((activity) => activity['_id'] == singleActivityId);
                            if (activities.length > 0) {
                                return (
                                    <div key={index}>
                                        <h4>{group['title']}</h4>
                                        <div className='main-side-accordian'>
                                            <Accordion
                                                key={`accordion-${group['_id']}-${accordionKey}`}
                                                allowMultipleExpanded={true}
                                                allowZeroExpanded={true}
                                                preExpanded={expandedActivities}>
                                                {activities.map((activity, actIndex) => {
                                                    // Calculate the global index for this activity
                                                    let globalIndex = 0;
                                                    for (let i = 0; i < index; i++) {
                                                        const prevGroup = singlePageData['activitiesGrouped'][i];
                                                        if (prevGroup?.['activities']) {
                                                            globalIndex += prevGroup['activities'].filter((act) => {
                                                                const typeMatch = selectedTab == 'all' || selectedTab == act?.['type'];
                                                                const userMatch = !userFilterActivity || userFilterActivity == 'All Users' || act?.['assignedTo']?.['_id'] == userFilterActivity || act?.['createdBy']?.['_id'] == userFilterActivity;
                                                                const searchMatch = !searchText || act?.['title']?.toLowerCase().includes(searchText.toLowerCase()) || act?.['description']?.toLowerCase().includes(searchText.toLowerCase());
                                                                return typeMatch && userMatch && searchMatch;
                                                            }).length;
                                                        }
                                                    }
                                                    globalIndex += actIndex;
                                                    return (
                                                        <ActivityCard
                                                            group={group}
                                                            index={globalIndex}
                                                            activity={activity}
                                                            singlePageData={singlePageData}
                                                            key={`a-${activity['type']}-${actIndex}`}
                                                        />
                                                    )
                                                })}
                                            </Accordion>
                                        </div>
                                    </div>
                                )
                            }
                            return null;
                        }).filter(Boolean);

                        if (filteredGroups.length === 0) {
                            return <div style={{ textAlign: 'center', padding: '40px 20px', color: '#89868D' }} className='notfound-area'>
                                <div className='img-box'> <img alt="..." src={require('../../static/img/not-found.png')} /> </div>
                                <p>No activities match the selected filters</p>
                            </div>
                        }
                        return filteredGroups;
                    })()}
                </div>
            </div>
        </div>
    )
}

export default AllActivities